import { ApplicationState } from 'store'
import { readFollowAgent } from './reducer'

export const selectFollowAgent = (state: ApplicationState): boolean =>
  state.socket.followAgent ?? readFollowAgent()

/** The user is editing the interface on screen, or has unsaved edits on it. */
export const selectIsEditingInterface = (state: ApplicationState, interfaceId: string): boolean =>
  !!state.app.interface.editMode || state.app.interface.interfaceWithChanges?.id === interfaceId

/** Work the user has not confirmed yet, which following the agent must never discard. */
export const selectHasUnconfirmedUserChanges = (state: ApplicationState): boolean =>
  !!state.app.model.diagram?.unconfirmedNodes?.length ||
  !!state.app.model.codeDraftNodeId ||
  !!state.app.interface.editMode ||
  !!state.app.interface.interfaceWithChanges?.id
